let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ZZ0i")).then(() => parcelRequire('8siTg'));